import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'; // Note: Removed Switch
import './App.css';
import Inward from './Pages/Inward';
import Login from './Pages/Login';
import Receive from './Pages/Receive';
import Search from './Pages/Search';
import Stock from './Pages/Stock';
import Store from './Pages/Store';
import ProtectedRoute from './ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/inward"
          element={
            <ProtectedRoute>
              <Inward />
            </ProtectedRoute>
          }
        />
        <Route
          path="/receive"
          element={
            <ProtectedRoute>
              <Receive />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stock"
          element={
            <ProtectedRoute>
              <Stock />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory"
          element={
            <ProtectedRoute>
              <Store />
            </ProtectedRoute>
          }
        />
        <Route
          path="/search"
          element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
